// extracted by mini-css-extract-plugin
export default {"wrapper":"acceptance_wrapper__mdAwy","text":"acceptance_text__3g6x8"};